import React from 'react';
import Modal from './ui/Modal';
import Button from './ui/Button';

const TermsModal = ({ isOpen, onClose }) => {
  return (
    <Modal isOpen={isOpen} onClose={onClose} title="Termos de Uso - Barberize">
      <div className="space-y-4 max-h-96 overflow-y-auto pr-2">
        <div className="bg-indigo-50 p-4 rounded-lg">
          <p className="text-sm text-indigo-900">
            <strong>Última atualização:</strong> Novembro de 2025
          </p>
        </div>

        <div>
          <h3 className="font-semibold text-gray-900 mb-2">1. Aceitação dos Termos</h3>
          <p className="text-sm text-gray-600">
            Ao criar uma conta e utilizar a plataforma Barberize, você concorda com estes 
            termos de uso. Se você não concordar com qualquer parte destes termos, não deve 
            utilizar nossos serviços.
          </p>
        </div>

        <div>
          <h3 className="font-semibold text-gray-900 mb-2">2. Descrição do Serviço</h3>
          <p className="text-sm text-gray-600">
            O Barberize é uma plataforma digital que conecta clientes a barbearias, 
            permitindo o agendamento online de serviços de barbearia. Oferecemos:
          </p>
          <ul className="list-disc list-inside text-sm text-gray-600 mt-2 space-y-1">
            <li>Sistema de agendamento online</li>
            <li>Gerenciamento de horários disponíveis</li>
            <li>Notificações de confirmação e lembretes</li>
            <li>Perfis de barbearias e clientes</li>
            <li>Sistema de avaliações</li>
          </ul>
        </div>

        <div>
          <h3 className="font-semibold text-gray-900 mb-2">3. Cadastro e Conta</h3>
          <p className="text-sm text-gray-600 mb-2">
            Para utilizar nossos serviços, você deve:
          </p>
          <ul className="list-disc list-inside text-sm text-gray-600 space-y-1">
            <li>Ter pelo menos 18 anos de idade</li>
            <li>Fornecer informações verdadeiras e atualizadas</li>
            <li>Manter a segurança de sua senha</li>
            <li>Notificar-nos imediatamente sobre uso não autorizado de sua conta</li>
            <li>Ser responsável por todas as atividades realizadas em sua conta</li>
          </ul>
        </div>

        <div>
          <h3 className="font-semibold text-gray-900 mb-2">4. Agendamentos</h3>
          <p className="text-sm text-gray-600 mb-2">
            Ao realizar um agendamento, você concorda que:
          </p>
          <ul className="list-disc list-inside text-sm text-gray-600 space-y-1">
            <li>As informações fornecidas são corretas</li>
            <li>Você comparecerá no horário agendado</li>
            <li>Cancelamentos devem ser feitos com antecedência</li>
            <li>A barbearia pode cobrar taxas por não comparecimento</li>
            <li>O Barberize não é responsável pela qualidade do serviço prestado</li>
          </ul>
        </div>

        <div>
          <h3 className="font-semibold text-gray-900 mb-2">5. Responsabilidades do Usuário</h3>
          <p className="text-sm text-gray-600 mb-2">
            Você concorda em NÃO:
          </p>
          <ul className="list-disc list-inside text-sm text-gray-600 space-y-1">
            <li>Usar a plataforma para fins ilegais</li>
            <li>Publicar conteúdo ofensivo ou inadequado</li>
            <li>Tentar acessar contas de outros usuários</li>
            <li>Interferir no funcionamento da plataforma</li>
            <li>Usar bots ou automações não autorizadas</li>
            <li>Fornecer avaliações falsas ou enganosas</li>
          </ul>
        </div>

        <div>
          <h3 className="font-semibold text-gray-900 mb-2">6. Pagamentos e Valores</h3>
          <p className="text-sm text-gray-600">
            Os valores dos serviços são definidos pelas barbearias. O Barberize não é 
            responsável por cobranças, reembolsos ou disputas financeiras entre clientes e 
            barbearias. O pagamento é realizado diretamente no estabelecimento.
          </p>
        </div>

        <div>
          <h3 className="font-semibold text-gray-900 mb-2">7. Propriedade Intelectual</h3>
          <p className="text-sm text-gray-600">
            Todo o conteúdo da plataforma (design, código, logos, textos) é propriedade do 
            Barberize ou de seus licenciadores e está protegido por leis de propriedade 
            intelectual.
          </p>
        </div>

        <div>
          <h3 className="font-semibold text-gray-900 mb-2">8. Limitação de Responsabilidade</h3>
          <p className="text-sm text-gray-600">
            O Barberize atua como intermediador. Não somos responsáveis por:
          </p>
          <ul className="list-disc list-inside text-sm text-gray-600 mt-2 space-y-1">
            <li>Qualidade dos serviços prestados pelas barbearias</li>
            <li>Cancelamentos ou não comparecimento</li>
            <li>Danos ou prejuízos decorrentes do uso da plataforma</li>
            <li>Interrupções ou falhas técnicas</li>
            <li>Perda de dados</li>
          </ul>
        </div>

        <div>
          <h3 className="font-semibold text-gray-900 mb-2">9. Modificações nos Termos</h3>
          <p className="text-sm text-gray-600">
            Reservamos o direito de modificar estes termos a qualquer momento. Alterações 
            significativas serão notificadas por email. O uso continuado da plataforma após 
            as alterações constitui aceitação dos novos termos.
          </p>
        </div>

        <div>
          <h3 className="font-semibold text-gray-900 mb-2">10. Rescisão</h3>
          <p className="text-sm text-gray-600">
            Podemos suspender ou encerrar sua conta a qualquer momento, sem aviso prévio, 
            em caso de violação destes termos. Você pode encerrar sua conta a qualquer momento 
            através das configurações de perfil.
          </p>
        </div>

        <div>
          <h3 className="font-semibold text-gray-900 mb-2">11. Lei Aplicável</h3>
          <p className="text-sm text-gray-600">
            Estes termos são regidos pelas leis do Brasil. Quaisquer disputas serão 
            resolvidas nos tribunais competentes.
          </p>
        </div>

        <div>
          <h3 className="font-semibold text-gray-900 mb-2">12. Contato</h3>
          <p className="text-sm text-gray-600">
            Para dúvidas sobre estes termos, entre em contato:
            <br />
            <strong>Email:</strong> barberizeapp01@gmail.com
            <br />
            <strong>Site:</strong> barberize.uk
          </p>
        </div>
      </div>

      <div className="mt-6">
        <Button
          variant="primary"
          onClick={onClose}
          className="w-full"
        >
          Fechar
        </Button>
      </div>
    </Modal>
  );
};

export default TermsModal;
